import { useSelector } from 'react-redux';
import { useDeviceType } from '../hooks/useDeviceType';
import { useEffect, useRef } from 'react';
import { allowDrop, drop } from '../js/webGL';

export function Product() {
  const device = useDeviceType();
  const containerRef = useRef(null);
  const isMobile = device === 'mobile';

  const { isReview } = useSelector((state) => state.ui);

  useEffect(() => {
    if (!containerRef?.current) return;
    if (isReview || !isMobile) {
      containerRef.current.style.height = '100%';
    }
  }, [containerRef, isMobile, isReview]);

  return (
    <div
      className={isMobile ? 'mobile-product' : 'tablet-product'}
      style={{
        backgroundImage: 'url(/theme/img/background/Center01.svg)',
        backgroundSize: '85%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        backgroundOrigin: 'border-box',
        height: isReview || !isMobile ? '100dvh' : 'calc(100dvh - 300px)',
      }}
    >
      <div
        ref={containerRef}
        style={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          zIndex: '10',
          display: 'flex',
          justifyContent: 'center',
        }}
        id="container"
        onDrop={(evt) => drop(evt)}
        onDragOver={(evt) => allowDrop(evt)}
      ></div>
    </div>
  );
}
